const currency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export const formatPrice = (value: number) => currency.format(value);

/** Junta classes condicionais: cn("a", isOn && "b") */
export const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");

/** Minúsculas e sem acentos, para comparar nomes de categoria. */
export const normalizeText = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

export const capitalize = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

/** Adiciona parâmetros de redimensionamento às fotos do Unsplash sem query string. */
export const unsplash = (url: string, width = 800) =>
  url.includes("?") ? url : `${url}?auto=format&fit=crop&w=${width}&q=75`;
